import { ENDPOINTS, type FieldAccuracyResponse } from '@clm/shared-types';

import { apiGet } from './client';

/**
 * `GET /v1/admin/field-accuracy` — CLM-107 (FR-30, DR-08).
 *
 * The one read behind the Admin **Extraction accuracy** surface. No
 * parameters: there is nothing to filter or tune, and in particular no
 * threshold — that is CLM-108's, after ratification. The response is parsed
 * against the registry schema, whose refinements pin the arithmetic (a null
 * rate at n = 0, one current row per field), so an off-contract body is a
 * `ZodError`, never a table showing a plausible wrong number.
 *
 * NFR-06: no `scope` key is ever sent — scope is the API's, from the token;
 * `scope_kind` on the response is how the page learns it.
 */

const ENDPOINT = ENDPOINTS['field-accuracy'];

export async function fetchFieldAccuracy(signal?: AbortSignal): Promise<FieldAccuracyResponse> {
  const raw = await apiGet<unknown>(ENDPOINT.path, signal === undefined ? {} : { signal });
  return ENDPOINT.response.parse(raw);
}
